<script setup>
import { useAttrs } from 'vue';

/**
 * A single panel within HrTabPanels, shown when its name matches the active tab.
 *
 * Removes Quasar's default 16px padding, in every theme — content is responsible for its own
 * spacing, matching M3's expectation that surfaces define their own internal layout. A panel is a
 * navigation mechanism rather than a surface, and padding it indents the content away from
 * whatever header or dialog frame it sits in.
 *
 * @status recommended
 * @group navigation
 * @useWhen Providing the content pane for a single tab, shown when its name matches the active tab
 * @within hr-tab-panels
 * @related HrTabs
 * @see https://quasar.dev/vue-components/tab-panels Quasar q-tab-panel API
 */
defineOptions({ name: 'HrTabPanel' });

defineProps({
  /**
   * Identifier that matches the corresponding HrTab name. Required.
   */
  name: {
    type: [String, Number],
    required: true,
  },
});

const attrs = useAttrs();
</script>

<template>
  <q-tab-panel
    :name="name"
    v-bind="attrs"
    class="hr-tab-panel"
  >
    <!-- @slot Tab panel content. -->
    <slot />
  </q-tab-panel>
</template>

<style lang="scss" scoped>

.hr-tab-panel {
  padding: 0;
}

</style>
